import React from "react";
import SectionLabel from "./SectionLabel";

const ResearchList = ({ items }) => {
  return (
    <section className="scroll-mt-24">
      <SectionLabel>Research</SectionLabel>
      <ul className="m-0 flex list-none flex-col gap-3.5 p-0">
        {items.map((item) => (
          <li
            key={item.id}
            className="flex items-baseline justify-between gap-6 max-sm:flex-col max-sm:gap-1"
          >
            <div className="text-[15px] font-medium leading-snug text-zinc-950 dark:text-zinc-50">
              {item.title}
            </div>
            <div className="flex shrink-0 items-baseline gap-2 whitespace-nowrap text-[13px] text-zinc-500 max-sm:whitespace-normal">
              <span>{item.venue}</span>
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-zinc-400 underline decoration-1 underline-offset-2 dark:text-neutral-400"
              >
                {item.linkLabel}
              </a>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ResearchList;
